import imageCompressor from 'quill-image-compress';
import ReactQuill from 'react-quill';
import { useColorMode } from '@chakra-ui/react';
import getQuillStyles from './quillStyling';

ReactQuill.Quill.register('modules/imageCompress', imageCompressor);

export const useQuillConfig = () => {
  const { colorMode } = useColorMode();

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['blockquote', 'code-block'],
      ['link'],
      ['image'],
      ['clean'],
    ],
    imageCompress: {
      quality: 0.7,
      maxWidth: 1200,
      maxHeight: 800,
      imageType: 'image/jpeg',
      debug: false,
      suppressErrorLogging: false,
      handleOnPaste: true,
      maxFileSize: 5 * 1024 * 1024,
    },
  };

  const formats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'list',
    'bullet',
    'blockquote',
    'code-block',
    'link',
    'image',
  ];

  const style = getQuillStyles(colorMode);

  return { modules, formats, style };
};

export const calculateContentSize = (content) => {
  const bytes = new Blob([content]).size;
  return bytes / (1024 * 1024);
};
